import React from "react";

import { t } from "i18next";

export function Validate(props: any): JSX.Element {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 350 87"
        >
            <g
                id="Groupe_27"
                data-name="Groupe 27"
                transform="translate(-6346 4106)"
            >
                <g
                    id="Rectangle_21"
                    data-name="Rectangle 21"
                    transform="translate(6346 -4106)"
                    fill="#323333"
                    stroke="#000"
                    stroke-width="2"
                >
                    <rect width="350" height="87" rx="9" stroke="none" />
                    <rect
                        x="1"
                        y="1"
                        width="348"
                        height="85"
                        rx="8"
                        fill="none"
                    />
                </g>
                <text
                    id="Validate"
                    transform="translate(6521 -4048)"
                    fill="#fff"
                    font-size="38"
                    font-family="HelveticaNeue-Medium, Helvetica Neue"
                    font-weight="500"
                >
                    <tspan x="-59.147" y="0">
                        {t("Validate", {
                            lng: props.selectedLanguage,
                        })}
                    </tspan>
                </text>
            </g>
        </svg>
    );
}
